import React from 'react';
import AppDescriptionPage from './AppDescriptionPage';

// This wrapper is now handled directly in AppDescriptionPage.tsx
// with AppDescriptionPageWithNavigation component
const AppDescriptionPageWrapper = () => {
  return <AppDescriptionPage />;
};

export default AppDescriptionPageWrapper;
